import $ from "cash-dom";

$(function () {
  if (process.env.NODE_ENV == "production") {
    $('[data-event="dl"]').on("click", sendGAevent);
  }
});

function sendGAevent() {
  let data = $(this).data();
  ga("send", "event", data.category, data.action, data.label);
}
